<span nz-icon>
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 8.999c-.895 0-1.776.221-2.565.645A1 1 0 0 0 14 8.999h-4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a.998.998 0 0 0 1-1v-5.5a1 1 0 0 1 2 0v5.5a1 1 0 0 0 1 1h4a.998.998 0 0 0 1-1v-7.5a5.507 5.507 0 0 0-5.5-5.5Zm3.5 12h-2v-4.5a3 3 0 0 0-6 0v4.5h-2v-10h2v.703a1 1 0 0 0 1.781.625 3.482 3.482 0 0 1 6.22 2.172v6.5Zm-14-12H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h4a.998.998 0 0 0 1-1v-12a1 1 0 0 0-1-1Zm-1 12H4v-10h2v10ZM5.015 1.542a3.233 3.233 0 1 0-.057 6.457h.029a3.233 3.233 0 1 0 .028-6.457Zm-.028 4.457h-.029A1.222 1.222 0 0 1 3.59 4.771c0-.747.56-1.229 1.426-1.229A1.233 1.233 0 0 1 6.41 4.771c0 .746-.56 1.228-1.424 1.228Z"
      fill="currentColor"
    />
  </svg>
</span>
